import React, { useState, useEffect } from "react";
import styled from "styled-components";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import { MIN_INTERNET } from "../../layout/constants";

const Modal = ({ setValuesInternet, setCheckInternet }) => {
    const [value, setValue] = useState(0);

    useEffect(() => {
        const connection = navigator.connection;
        if (connection && connection.downlink) {
            setTimeout(() => {
                setValue(connection.downlink);
            }, 3000);

            //setValuesInternet(setValuesInternet);

        }
    }, []);

    const close = () => {
        setCheckInternet(false);
        setValuesInternet(value);
    };

    return (
        <>
            <Background />
            <Content>
                <h1>Test de internet</h1>
                {value !== 0 ?
                    <div>
                        <h4>Tu internet tiene una velocidad de <strong>{value} mb</strong></h4>
                        {value >= MIN_INTERNET ?
                            <h5>Tu internet, cuenta con una velocidad estable para realizar la prueba.</h5>
                            : <h5>Lo sentimos, tu internet tiene una velocidad baja por lo que puedes llegar a presentar inconvenientes, te recomendamos contactar al equipo de mentalia y agendar otra cita.</h5>
                        }
                        <Button
                            variant="contained" color="primary"
                            onClick={close}
                        >De acuerdo</Button>
                    </div>
                    :
                    <CircularProgress />
                }
            </Content>
        </>
    );
};

const Background = styled.section`
    background: rgb(0 0 0 / 25%);
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    
`;

const Content = styled.section`
    background: white;
    position: fixed;
    width: 50%;
    top: 10%;
    left: 25%;
    border-radius: 15px;
    min-height: 330px;
    & > h1 {
        font-size: 25px;
    }
    & > div >h4 {
        font-weight: 100;
    }
    & > div > h5 {
        font-weight: 100;
    }
`;

export default Modal;